import React, { useMemo } from "react";
import { withRouter } from "react-router";
import StarIcon from "./icono";

const RatingIcon = (props) => {
  const { index, rating, hoverRating } = props;
  const fill = useMemo(() => {
    if (hoverRating >= index) {
      return "#141E30 ";
    } else if (!hoverRating && rating >= index) {
      return "#141E30 ";
    }
    return "none";
  }, [rating, hoverRating, index]);
  return (
    <div
      className="cursor-pointer"
      onMouseEnter={() => props.onMouseEnter(index)}
      onMouseLeave={() => props.onMouseLeave()}
      onClick={() => props.onSaveRating(index)}
    >
      <StarIcon fill={fill} />
    </div>
  );
};

export default withRouter(RatingIcon);
